

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

// Overview page components
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";

// Data
import profilesListData from "layouts/profile/data/profilesListData";

// Images
import homeDecor1 from "assets/images/home-decor-1.jpg";
import homeDecor2 from "assets/images/home-decor-2.jpg";
import homeDecor3 from "assets/images/home-decor-3.jpg";
import homeDecor4 from "assets/images/home-decor-4.jpeg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { TabContext } from "@mui/lab";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";
import TabPanel from "@mui/lab/TabPanel";
import React, {memo, useState} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Fade from "@mui/material/Fade";
import Card from "@mui/material/Card";
import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { MuiDataGrid } from "../../components/MuiDatagrid";
import moment from "moment/moment";
import { enUS, zhCN } from "@mui/x-data-grid/locales";
import PrintPanel from "../inbounds/PrintPanel";
import InboundsEditor from "../inbounds/InboundsEditor";
import Button from "@mui/material/Button";
import { downloadInboundTemplate } from "../../actions/inbounds/inboundsAction";
import { MyFileUploader } from "../../components/FileUploaders/Uploader";
import { ASN_Import } from "../../config";
import PasswordSetting from "./passwordSetting/PasswordSetting";
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';
import PersonIcon from '@mui/icons-material/Person';
import PaymentIcon from '@mui/icons-material/Payment';
import HomeIcon from '@mui/icons-material/Home';
import UserInformation from "./userInformation/UserInformation";
import UserInfo from "./userInformation/UserInfo";
function Overview() {
  return (
    <DashboardLayout>
      <MDBox mb={2} />
      <Header/>
      <Footer />
    </DashboardLayout>
  );
}

export default memo(Overview);
